import { defineComponent as _defineComponent } from 'vue'
import { mdiArrowLeft, mdiDotsHorizontal } from '@mdi/js'
import { computed } from 'vue'
import BKButton from '@/components/AppShared/BKButton.vue'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import store from '@/store'
import { useImage } from '@/shared/composables/image'
import { userApi, UserDB } from '@/enitites/user'

interface IProps {
  loading: boolean
  user: UserDB
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsOtherProfiles',
  props: {
    loading: { type: Boolean },
    user: null
  },
  setup(__props: any) {

const { getImageById } = useImage()



async function setMainProfile(id: number) {
  const { data } = await userApi.setProfileAsMain(id)
  if (!data) return
  localStorage.removeItem('currentProfileId')
  await store.commit('SET_USER_DB', data)
}

const getUserDB = computed(() => store.getters.getUserDB)

return { __sfc: true,getImageById, setMainProfile, getUserDB, mdiArrowLeft, mdiDotsHorizontal, BKButton, store }
}

})